module.exports = __webpack_public_path__ + "static/media/logo_primary.47e8f492.svg";